$(document).ready(function () {
  if (!localStorage.getItem("customerTags")) customerData()
  if (CID) onPricesOnLoad()

  if ($(".product-information #AddToCart").length) {
    $(".product-information #AddToCart").click(function(e) {
      e.preventDefault()

      const quantity = 
        $(this)
        .parent()
        .find(".quantity")
        .val()

      addToBasket($(this), quantity)
    })
  }

  $("a[data-add]").click(function (e) {
    e.preventDefault()
  
    const quantity = parseInt(
      $(this)
        .parent()
        .parent()
        .find("input[type=number]")
        .val() ?? 1
    )
  
    addToBasket($(this), quantity)
  })

  if (CID2 && !$("#custom-cart").length) {
    const table = document.createElement("tr")
    table.classList.add("products_warning")

    const col = document.createElement("td")
    col.classList.add("col1")
    col.setAttribute("colspan", "100%")
    col.innerText = "Não existem produtos no seu carrinho."

    table.append(col)

    $("table.shop_table tbody.cart-box").prepend(table)
  }
})

function onPricesOnLoad() {
  if (SELLER !== "true") {
    loadCustomerPrices(CID)
    return
  }

  if (!localStorage.getItem("sellerChoice")) {
    showSellerPopup()
    return
  }

  const data = JSON.parse(localStorage.getItem("selectedAgentData"))

  if (data) {
    const buyerId = data?.[0]?.buyerId
    if (buyerId) loadCustomerPrices(buyerId)
  }
}

function rgpdPopup() {
  const modalContainer = document.createElement("div")
  modalContainer.className = "modal fade modal-backdrop"
  modalContainer.setAttribute("id", "rgpdModal")
  modalContainer.tabIndex = -1
  modalContainer.setAttribute("aria-hidden", "true")
  modalContainer.classList.add("show")

  const modalDialog = document.createElement("div")
  modalDialog.className = "modal-dialog modal-dialog-centered"

  const modalContent = document.createElement("div")
  modalContent.className = "modal-content"

  const modalBody = document.createElement("div")
  modalBody.className = "modal-body d-flex justify-content-center align-items-center flex-column"

  const title = document.createElement("h2")
  title.textContent = "Aceita o nosso RGPD?"

  const buttonsContainer = document.createElement("div")
  buttonsContainer.className = "content-buttons"

  const declineBtn = document.createElement("button")
  declineBtn.type = "button"
  declineBtn.className = "btn btn-secondary"
  declineBtn.setAttribute("id", "declineBtn")
  declineBtn.style.marginTop = "10px"
  declineBtn.textContent = "No"

  const acceptBtn = document.createElement("button")
  acceptBtn.type = "button"
  acceptBtn.className = "btn btn-primary"
  acceptBtn.setAttribute("id", "acceptBtn")
  acceptBtn.style.marginTop = "10px"
  acceptBtn.textContent = "Yes"

  buttonsContainer.append(declineBtn, acceptBtn)
  modalBody.append(title, buttonsContainer)
  modalContent.append(modalBody)
  modalDialog.append(modalContent)
  modalContainer.append(modalDialog)

  document.body.insertAdjacentElement("beforeend", modalContainer)
  document.body.style.overflow = "hidden"

  acceptBtn.addEventListener("click", () => localStorage.setItem("rgpdAccepted", true))
  declineBtn.addEventListener("click", () => localStorage.setItem("rgpdAccepted", false))
}

async function showSellerPopup() {
  const dataArray = []

  const modal = document.createElement("div")
  modal.className = "modal fade modal-backdrop"
  modal.setAttribute("id", "sellerModal")
  modal.tabIndex = -1
  modal.setAttribute("aria-hidden", "true")

  const modalDialog = document.createElement("div")
  modalDialog.className = "modal-dialog modal-dialog-centered"

  const modalContent = document.createElement("div")
  modalContent.className = "modal-content"

  const modalBody = document.createElement("div")
  modalBody.className = "modal-body d-flex justify-content-center align-items-center flex-column"

  const title = document.createElement("h2")
  title.textContent = "Vai vender por quem?"

  const buyerSelectContainer = document.createElement("div")
  buyerSelectContainer.setAttribute("id", "buyerSelectContainer")

  const confirmBtn = document.createElement("button")
  confirmBtn.type = "button"
  confirmBtn.className = "btn btn-primary d-none"
  confirmBtn.setAttribute("id", "confirmBtn")
  confirmBtn.style.marginTop = "10px"
  confirmBtn.textContent = "Confirme"

  modalBody.append(title, buyerSelectContainer, confirmBtn)
  modalContent.append(modalBody)
  modalDialog.append(modalContent)
  modal.append(modalDialog)

  document.body.insertAdjacentElement("beforeend", modal)
  document.body.style.overflow = "hidden"
  modal.classList.remove("fade")
  modal.classList.add("show")

  await getCustomerBuyers()

  confirmBtn.addEventListener("click", async function () {
    const buyerSelect = document.getElementById("buyerSelect")
    const opt = buyerSelect?.selectedOptions?.[0]
    const selectedValue = opt?.value ?? ""

    ["prices", "customerTags"]?.forEach((key) => {
      if (localStorage.getItem(key)) localStorage.removeItem(key)
    })

    if (selectedValue === CEMAIL) {
      localStorage.setItem("sellerChoice", true)

      dataArray.push({
        email: CEMAIL,
        buyerId: CID
      })

      localStorage.setItem(
        "selectedAgentData", 
        JSON.stringify(dataArray)
      )

      await loadCustomerPrices(CID)

      document.body.style.overflow = "auto"

      modal.classList.add("fade")
      modal.classList.remove("show")
    } else {
      const selectedOption = buyerSelect.options[buyerSelect.selectedIndex]
      const routes = selectedOption.getAttribute("data-routes")
      const email = selectedOption.getAttribute("data-email")
      const name = selectedOption.getAttribute("data-agent-name")
      const buyer = await getCustomerData(email)

      dataArray.push({
        email,
        name,
        selectedValue,
        buyer
      })

      localStorage.setItem(
        "selectedAgentData", 
        JSON.stringify(dataArray)
      )

      if (localStorage.getItem("iecas")) localStorage.removeItem("iecas")

      await loadCustomerPrices(buyer?.id)

      if (routes) {
        const routeArray = routes
          .split(",")
          .map((r) => r.trim())
          .filter(Boolean)

        if (routeArray.length) {
          await populateRouteSelect(routeArray)

          document.body.style.overflow = "auto"

          modal.classList.add("fade")
          modal.classList.remove("show")
        }
      }
    }

    await getBasket()
    window.location.reload()
  })
}

async function getCustomerData(email) {
  try {
    const res = await fetch(`${ENDPOINT}?action=customer_data&store=${STORE}&email=${encodeURIComponent(email)}`);
    if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
    const json = await res.json();
    const list =
      Array.isArray(json?.data?.data) ? json.data.data :
      Array.isArray(json?.data)       ? json.data       :
      Array.isArray(json)             ? json            : [];
    return list[0] ?? null;
  } catch (err) {
    console.error('getCustomerData:', err);
    return null;
  }
}

function getCustomerBuyers() {
  const buyerContainer = document.querySelector("#buyerSelectContainer");
  buyerContainer.querySelector("i")?.remove();

  const buyerSpinner = document.createElement("i");
  buyerSpinner.classList.add("fa", "fa-spinner", "fa-spin");
  buyerContainer.append(buyerSpinner);

  return fetch(`${ENDPOINT}?action=customer_buyers&store=${STORE}&email=${encodeURIComponent(CEMAIL)}`)
    .then(res => {
      if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
      return res.json();
    })
    .then(data => {
      if (Number(data.status) && Array.isArray(data.customers)) {
        const buyerSelect = document.createElement("select");
        buyerSelect.id = "buyerSelect";

        data.customers.forEach(c => {
          const opt = new Option(
            [c.company, `(${c.firstname}`, `${c.lastname})`].join(" ").trim(),
            String(c.customer_sales_agent_id ?? "")
          );
          opt.dataset.agentName = c?.sales_agent_name?.trim() ?? "";
          opt.dataset.routes = Array.isArray(c.customer_routes_list)
            ? c.customer_routes_list.join(",")
            : (c.customer_routes_list ?? "");
          opt.dataset.email = (c.email ?? "").trim();
          buyerSelect.add(opt);
        });

        const cEmailOpt = Array.from(buyerSelect.options).find(
          o => (o.dataset.email || '').trim().toLowerCase() === (CEMAIL || '').trim().toLowerCase()
        );

        if (cEmailOpt && buyerSelect.firstElementChild !== cEmailOpt) {
          buyerSelect.insertBefore(cEmailOpt, buyerSelect.firstChild);
        }

        buyerContainer.replaceChildren(buyerSelect);
        document.querySelector("#sellerModal #confirmBtn")?.classList.remove("d-none");

        const options = Array.from(buyerSelect.options);
        const norm = s => String(s ?? "").trim().toLowerCase();

        let savedEmail = null;
        try {
          const saved = JSON.parse(localStorage.getItem("selectedAgentData") || "[]");
          const savedItem = Array.isArray(saved) ? saved.find(x => x && x.email) : null;
          savedEmail = savedItem ? savedItem.email : null;
        } catch {}

        const pickByEmail = (email) =>
          options.find(o => norm(o.dataset.email) === norm(email));

        const preferredOption =
          (savedEmail && pickByEmail(savedEmail))
          || pickByEmail(CEMAIL);

        if (preferredOption) preferredOption.selected = true;
      }
    })
    .catch(console.error)
    .finally(() => buyerSpinner.remove());
}

function populateRouteSelect(favoriteRoutes) {
  const routeText = document.createElement("p")
  routeText.innerText = "Selecione a rota pretendida."

  const routeSelect = document.createElement("select")
  routeSelect.setAttribute("id", "buyer_select")
  routeSelect.setAttribute("onchange", "routeSelected()")

  const routeDefaultOption = document.createElement("option")
  routeDefaultOption.innerText = "Selecione a rota"
  routeDefaultOption.disabled = true
  routeDefaultOption.value = ""

  routeSelect.append(routeDefaultOption)

  if (favoriteRoutes?.length) {
    const optionsGroup = document.createElement("optgroup")
    optionsGroup.setAttribute("label", "Favoritos")

    favoriteRoutes.forEach((route, index) => {
      const otherRouteOption = document.createElement("option")
      otherRouteOption.innerText = route
      otherRouteOption.value = route

      if (!index) otherRouteOption.selected = true

      optionsGroup.append(otherRouteOption)
    })

    routeSelect.append(optionsGroup)
  }

  fetch(`${ENDPOINT}?action=customers_routes&store=${STORE}`)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`${res.status} ${res.statusText}`)  
      }

      return res.json()
    })
    .then(({ data }) => {
      if (data?.length) {
        const altOptionsGroup = document.createElement("optgroup")
        altOptionsGroup.setAttribute("label", "Outros")

        data.forEach((r) => {
          if (!favoriteRoutes.includes(r)) {
            const altRouteOption = document.createElement("option")
            altRouteOption.innerText = r
            altRouteOption.value = r

            altOptionsGroup.append(altRouteOption)
          }
        })

        routeSelect.append(altOptionsGroup)

        localStorage.setItem("buyerRoutesHTML", routeSelect.outerHTML)
        localStorage.setItem("sellerChoice", true)
      }
    })
    .catch(console.error)
}

function routeSelected() {
  const select = document.getElementById("buyer_select")

  if (!select) return false

  const selectedRoute = select.value
  const data = JSON.parse(localStorage.getItem("selectedAgentData")) || []

  if (data?.length) {
    data[0] = { 
      ...data[0], 
      route: selectedRoute 
    }

    localStorage.setItem("selectedAgentData", JSON.stringify(data))
    return true
  }

  return false
}

function updateCartAttributes(attributes) {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(attributes),
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`${res.status} ${res.statusText}`)  
      }

      return res.json()
    })
    .then(console.log)
    .catch(console.error)
}

function loadCustomerPrices(customerID = CID2) {
  $("table.shop_table tbody tr.products_warning").show()

  async function endLoad(prices, iecas) {
    if ($(".template-index")?.length && typeof getData === 'function') {
      await getData()
    }

    if ($(".template-collection")?.length && typeof getDataCustomers === 'function') {
      await getDataCustomers()
    }

    customPrices(prices)
    iecaProducts(iecas)
  }

  if (customerID) {
    showLoadingModal("A carregar preços...")

    fetch(`${ENDPOINT}?store=0&action=customer_prices&id=${customerID}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`${res.status} ${res.statusText}`)  
        }

        return res.json()
      })
      .then(async ({ data }) => {
        const dataPrices = Object.fromEntries(
          Object.entries(data).filter(([key]) => key !== "iecas")
        )

        storeInMemory("iecas", data.iecas, 1)
        storeInMemory("prices", data.prices ?? dataPrices, 1)
        endLoad(dataPrices, data.iecas)
      })
      .catch((error) => {
        showLoadingModal("Não foi possível carregar as preços")
        console.error(error)
      })
      .finally(() => removeLoadingModal())
  }
}

function iecaProducts(iecas) {
  const skuEl = document.querySelector("#product-sku")

  if (document.querySelectorAll(".product-single__price").length && skuEl) {
    const sku = skuEl.textContent.trim()
    const item = iecas[sku]

    if (item?.value) {
      const product = skuEl.parentElement
      const title = product?.parentElement?.querySelector(".product-single__title")
      const price = product?.parentElement?.querySelector(".product-price__price")

      if (price) {
        const iecaLabel = document.createElement("label")
        iecaLabel.className = "ieca-price"
        iecaLabel.style.marginLeft = "10px"
        iecaLabel.style.fontSize = "12px"

        const iecaStrong = document.createElement("strong")
        iecaStrong.textContent = "IECA:"

        iecaLabel.append(
          document.createTextNode("("),
          iecaStrong,
          document.createTextNode(` €${item.value})`)
        )

        price.insertAdjacentElement("afterend", iecaLabel)
      }

      if (title) {
        const iecaSpan = document.createElement("span")
        iecaSpan.className = "ieca-label-prod-page"

        const iecaSpanStrong = document.createElement("strong")
        iecaSpanStrong.textContent = "IECA"
        iecaSpan.append(iecaSpanStrong)

        title.appendChild(iecaSpan)
      }
    }
  }

  document.querySelectorAll(".custom-price").forEach((i) => {
    const thisSku = i.getAttribute("data-sku")
    const item = thisSku ? iecas[thisSku] : null

    if (item?.value) {
      const wrapper = i.closest(".product-wrapper")
      if (!wrapper) return

      // Mostrar preço IECA (e.g. IECA: €0.04) [REMOVIDO]
      /*
        const p = document.createElement("p")
        p.className = "ieca-price"
        p.style.fontSize = "12px"

        const strong = document.createElement("strong")
        strong.textContent = "IECA:"
        p.append(strong, document.createTextNode(` €${item.value}`))

        const cPrice = wrapper.querySelector(".custom-price")
        if (cPrice) cPrice.insertAdjacentElement("afterend", p)
      */

      const cImg = wrapper.querySelector(".product-image")

      const badge = document.createElement("span")
      badge.className = "ieca-label"

      const bStrong = document.createElement("strong")
      bStrong.textContent = "IECA"

      badge.append(bStrong)

      if (cImg) cImg.appendChild(badge)
    }
  })
}

function customPrices(data = loadFromMemory("prices")) {
  const EUR = new Intl.NumberFormat("pt-PT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })

  function parsePrice(value) {
    if (value == null) return null

    let s = String(value).trim().replace(/[^\d.,-]/g, '')
    if (!s) return null

    const hasComma = s.includes(',')
    const hasDot = s.includes('.')

    if (hasComma && hasDot) {
      const lastComma = s.lastIndexOf(',')
      const lastDot = s.lastIndexOf('.')

      if (lastComma > lastDot) {
        s = s.replace(/\./g, '').replace(',', '.')
      } else {
        s = s.replace(/,/g, '')
      }
    } else if (hasComma) {
      const [intPart, decPart] = s.split(',')

      if (decPart && decPart.length <= 2) {
        s = intPart.replace(/\./g, '') + '.' + decPart
      } else {
        s = s.replace(/,/g, '')
      }
    } else if (hasDot) {
      const [intPart, decPart] = s.split('.')
      if (!(decPart && decPart.length <= 2)) {
        s = s.replace(/\./g, '')
      }
    }

    const n = Number(s)
    return Number.isFinite(n) ? n : null
  }

  function getPriceFromData(sku, d) {
    const candidates = [
      d?.value?.[sku],
      d?.[sku]?.value,
      d?.[sku]
    ]

    for (const c of candidates) {
      const val = parsePrice(c)
      if (val != null && val > 0) return val
    }

    return null
  }

  function needsUpdate(el) {
    const current = parsePrice(el?.dataset?.price)
    const textEmpty = !el.textContent || el.textContent.trim() === ""

    return current == null || textEmpty
  }

  function setPrice(el, price, sku) {
    const fixed = price.toFixed(2)
    el.setAttribute("data-price", fixed)

    if (sku) el.setAttribute("data-sku", sku)
    el.textContent = EUR.format(price)
  }

  document.querySelectorAll(".custom-price").forEach((el) => {
    const sku = el.dataset?.sku || ""
    if (!sku) return

    if (needsUpdate(el)) {
      const price = getPriceFromData(sku, data)
      if (price != null) setPrice(el, price, sku)
    }
  })

  const priceEls = document.querySelectorAll(".product-single__price")
  const skuEl = document.querySelector("#product-sku")

  if (priceEls.length && skuEl) {
    const sku = skuEl.textContent.trim()
    const price = getPriceFromData(sku, data)

    if (price != null) {
      priceEls.forEach((priceEl) => {
        const current = parsePrice(priceEl.dataset?.price ?? priceEl.textContent)
        const textEmpty = !priceEl.textContent || priceEl.textContent.trim() === ""

        if (textEmpty || current == null) {
          if (priceEl.dataset) priceEl.dataset.price = price.toFixed(2)
          priceEl.textContent = EUR.format(price)
        }
      })
    }
  }
}

function getBasket() {
  if (!CID2) return

  showLoadingModal("A carregar cabaz...")

  fetch(`${ENDPOINT}?action=marvanejo_get_basket&store=0&customer=${CID2}`)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`${res.status} ${res.statusText}`)  
      }

      return res.json()
    })
    .then((data) => {
      const status = Number(data.status)
      const total = Number(data.total)
      
      const q = document.querySelector(".cart-products-count")
      if (q && q.textContent != total) q.textContent = total

      if (status === 1) {
        if (total) $("table.shop_table tbody tr.products_warning").hide()
        cabazGenerate(data)
      }
    })
    .catch((error) => {
      console.error(error)
      showLoadingModal("Erro de comunicação! Tente novamente.", true)
    })
    .finally(removeLoadingModal)
}

function cabazModalOpen() {
  $("#productsModal").modal("show")
}

function cabazModalClose() {
  $("#productsModal").modal("hide")
  $(".remove-product, .quantity-nav .quantity-button").unbind()
}

function cabazGenerate(data) {
  const price = data?.counts?.details?.totals?.price
  const priceAfterTaxes = data?.counts?.details?.totals?.price_with_tax
  const subtotal = document.querySelector(".cart__subtotal")
  const subtotalAfterTaxes = document.querySelector(".cart__subtotal_with_tax")

  if (subtotal) subtotal.innerText = convertPrice(price)
  if (subtotalAfterTaxes) subtotalAfterTaxes.innerText = convertPrice(priceAfterTaxes)

  const tBody = document.querySelector("#productsModal tbody")

  if (tBody) tBody.innerHTML = data.html

  const tables = document.querySelectorAll("table.products_cabaz .basket_content tr")

  if (!tables.length) {
    const basket = document.querySelector("table.shop_table tr.basket_content")
    basket?.remove()

    cabazModalClose()

    if (Number(data.total)) $("table.shop_table tbody tr.products_warning").hide()

    return
  }

  const items = data.data ?? []
  let total = 0

  items.forEach((i) => total += parseFloat(i.price) * i.quantity)

  const basketContent = document.createElement("tr")
  basketContent.className = "basket_content"

  const imgCol = document.createElement("td")

  const img = document.createElement("img")
  img.src = "https://marvanejo.apps.bydas.com/storage/cabaz.jpg"
  img.width = "50"
  img.height = "50"
  img.style.objectFit = "cover"

  imgCol.append(img)

  const anchorCol = document.createElement("td")

  const anchor = document.createElement("a")
  anchor.href = "#"
  anchor.className = "prod_title_cabaz"

  const span = document.createElement("span")
  span.style.fontSize = "10px"
  span.style.textTransform = "lowercase"
  span.innerText = "Clique aqui para ver os produtos"

  anchor.append(
    document.createTextNode("Encomenda"),
    document.createElement("br"),
    span
  )

  anchorCol.append(anchor)

  const quantityCol = document.createElement("td")
  quantityCol.className = "prod_quantity_cabaz"
  quantityCol.innerText = data.total

  const valueCol = document.createElement("td")
  valueCol.className = "basket_value"
  valueCol.value = total.toFixed(2)
  valueCol.innerText = convertPrice(total)

  basketContent.append(imgCol, anchorCol, quantityCol, valueCol)

  const cartBox = document.querySelector("table.shop_table tbody.cart-box")
  const previousBasketContent = cartBox.querySelector(".basket_content")
  previousBasketContent?.remove()

  cartBox.prepend(basketContent)

  cabazQuantities()

  $(".prod_title_cabaz").click((cabazModalOpen))
  $(".products-modal-close").click(cabazModalClose)
}

function cabazQuantities() {
  document.querySelectorAll(".quantity").forEach((q) => {
    const input = q.querySelector('input[type="number"]')

    if (!input) return

    const quantityNav = document.createElement("div")
    quantityNav.className = "quantity-nav"

    const quantityBtnUp = document.createElement("div")
    quantityBtnUp.className = "quantity-button quantity-up"
    quantityBtnUp.textContent = "+"

    const quantityBtnDown = document.createElement("div")
    quantityBtnDown.className = "quantity-button quantity-down"
    quantityBtnDown.textContent = "-"

    quantityNav.append(quantityBtnUp, quantityBtnDown)
    input.insertAdjacentElement("afterend", quantityNav)

    const hasMin = input.hasAttribute("min")
    const hasMax = input.hasAttribute("max")
    const min = hasMin ? Number(input.getAttribute("min")) : -Infinity
    const max = hasMax ? Number(input.getAttribute("max")) : Infinity

    const dispatchChange = () => {
      input.dispatchEvent(new Event("change", { bubbles: true }))
    }

    quantityBtnUp.addEventListener("click", () => {
      const value = Number(input.value)

      if (value < max) {
        input.value = String(value + 1)
      }

      dispatchChange()
    })

    quantityBtnDown.addEventListener("click", () => {
      const value = Number(input.value)

      if (value > min) {
        input.value = String(value - 1)
      }

      dispatchChange()
    })
  })

  const removeProductBtns = document.querySelectorAll(".remove-product")

  removeProductBtns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault()

      const btn = e.currentTarget
      const sku = btn.getAttribute("sku-value")
      const parent = btn.parentElement?.parentElement || null

      cabazRemove(sku, parent)
    })
  })

  document.querySelectorAll('.quantity input[type="number"]').forEach((inp) => {
    inp.addEventListener("change", () => {
      cabazUpdateQuantity(inp)
    })
  })
}

function addToBasket(cartButton, quantityValue) {
  if (!CID2) return;

  const $btn = window.jQuery && cartButton instanceof jQuery ? cartButton : null;
  const el   = $btn ? $btn[0] : cartButton;

  if (!el) return;

  const getAttr = (name) => {
    if ($btn) return $btn.attr(name);
    return el.getAttribute(name);
  };
  const getData = (name) => {
    if (el.dataset && name in el.dataset) return el.dataset[name];
    return getAttr(`data-${name}`);
  };

  const qty = Math.max(1, Number(quantityValue || 1) || 1);

  const sku = getData("add") ?? getData("sku");
  if (!sku) {
    console.error("SKU ausente em data-add do botão.");
    return;
  }

  showLoadingModal("A adicionar o produto ao carrinho");

  let image = "";
  try {
    if (document.querySelector(".template-index")) {
      image = getAttr("data-image") || document.querySelector(".product-image img")?.getAttribute("src") || "";
    } else if (document.querySelector(".template-product")) {
      image = document.querySelector(".product-single img.product-single__photo")?.getAttribute("src") || "";
    } else if (document.querySelector(".template-collection")) {
      image = getAttr("data-image") || "";
    } else if (el.classList.contains("bestsell-customer")) {
      image = getAttr("data-image") || "";
    } else if (document.querySelector(".template-customers-account")) {
      image = getAttr("data-image") || "";
    }
  } catch (_) {
    image = "";
  }

  const bodyData = {
    action: "marvanejo_add_to_basket",
    customer: CID2,
    sku: sku,
    quantity: qty,
    store: 0,
    image: image || ""
  };

  const formBody = new URLSearchParams();
  Object.entries(bodyData).forEach(([k, v]) => formBody.append(k, String(v)));

  fetch(ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Accept": "application/json, text/plain, */*"
    },
    body: formBody.toString(),
    credentials: "same-origin"
  })
    .then((res) => {
      if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
      return res.json();
    })
    .then((payload) => {
      const { status, total, basket, promo, msg } = payload || {};

      if (Number(status)) {
        const q = document.querySelector(".cart-products-count");
        if (q) {
          if (typeof total !== "undefined") {
            q.dataset.basket = String(total);
            q.textContent = String(total);
          }
          if (typeof promo !== "undefined") q.dataset.flyer = String(promo);
        }

        setMoreCartItemCount(qty);
        getCartsCount(total, basket, promo);
      } else {
        showLoadingModal(msg ?? "Não foi possível adicionar o produto ao carrinho.", true);
      }
    })
    .catch((error) => {
      console.error(error);
      showLoadingModal("Erro de comunicação! Tente novamente", true);
    })
    .finally(() => removeLoadingModal());
}

function setMoreCartItemCount(quantity) {
  const count = document.querySelector(".cart-products-count")

  if (count) {
    const flyer = Number(count.getAttribute("data-flyer"))
    const basket = Number(count.getAttribute("data-basket"))
    const total = flyer + basket - quantity

    getCartsCount(total, basket, flyer)
  }
}

function cabazRemove(elementSku, parentElement) {
  if (!CID2) return

  const bodyData = {
    action: "marvanejo_remove_from_basket",
    customer: CID2,
    sku: elementSku
  }

  const formBody = new URLSearchParams(bodyData)

  fetch(ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Accept": "application/json, text/plain, */*"
    },
    body: formBody.toString()
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error(`${res.status} ${res.statusText}`)
      }

      const ct = res.headers.get("content-type") || ""
      return ct.includes("application/json") ? res.json() : res.text()
    })
    .then((payload) => {
      const { status, msg } = payload
      
      if (Number(status)) {
        getBasket()
      } else {
        showLoadingModal(msg, true)
      }
    })
    .catch((error) => {
      console.error(error)
      showLoadingModal("Erro de comunicação. Tente novamente", true)
    })
    .finally(() => removeLoadingModal())
}

function cabazUpdateQuantity(element) {
  if (!CID2 || !element) return

  showLoadingModal("A atualizar quantidade...")

  const table = element?.parentElement?.parentElement?.parentElement

  if (table) {
    const input = table.querySelector("input")

    const bodyData = {
      action: "marvanejo_update_basket_quantity",
      customer: CID2,
      sku: input?.getAttribute("sku-value"),
      quantity: input?.value
    }

    const formBody = new URLSearchParams(bodyData)

    fetch(ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Accept": "application/json, text/plain, */*"
      },
      body: formBody.toString()
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`${res.status} ${res.statusText}`)
        }

        const ct = res.headers.get("content-type") || ""
        return ct.includes("application/json") ? res.json() : res.text()
      })
      .then(async (payload) => {
        const {
          status,
          total,
          basket,
          flyer,
          msg
        } = payload
        
        if (Number(status)) {
          await getBasket()
          getCartsCount(total, basket, flyer)
        } else {
          showLoadingModal(msg ?? "Dados corruptos", true)
        }
      })
      .catch((error) => {
        console.error(error)
        showLoadingModal("Erro de comunicação. Tente novamente", true)
      })
      .finally(removeLoadingModal)
  } else {
    removeLoadingModal()
  }
}
